export default __webpack_public_path__ + "static/media/ic_round-push-pin-colored.73b1f3e8.svg";